module.exports = __webpack_public_path__ + "static/media/VR1@2x.75e40bb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/VR/VR1@2x.png
// module id = 727
// module chunks = 0